import { sectionAspectRatio } from "@/shared/utils/aspect-ratio";
import { sectionMaxHeight } from "@/shared/utils/section-max-height";
import { StoreTemplate } from "@/templates/TemplateLoader";
import { FormattedDataType } from "@/templates/types";
import React from "react";

interface RenderAttributeCardProps {
  attributeValue: FormattedDataType["attributeValues"][0];
  section: Partial<FormattedDataType>;
  isSliderSection?: boolean;
  isOneElement?: boolean;
}

const RenderAttributeCard: React.FC<RenderAttributeCardProps> = ({
  attributeValue,
  section,
  isSliderSection,
  isOneElement,
}) => {
  const Template = StoreTemplate.get();
  return (
    <Template.SectionCardWrapper
      isSlider={isSliderSection}
      data-test="attributeValue-card"
      background={section?.background}
      aspectRatio={sectionAspectRatio(attributeValue.image, isOneElement)}
      maxHeight={sectionMaxHeight(attributeValue.image, isOneElement)}
    >
      <Template.AttributeValueCard
        attributeValue={attributeValue}
        hideTitle={!section?.showItemName}
      />
    </Template.SectionCardWrapper>
  );
};

export default RenderAttributeCard;
